import { render, staticRenderFns } from "./job-tag.vue?vue&type=template&id=708fc332&scoped=true"
import script from "./job-tag.vue?vue&type=script&lang=js"
export * from "./job-tag.vue?vue&type=script&lang=js"
import style0 from "./job-tag.vue?vue&type=style&index=0&id=708fc332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708fc332",
  null
  
)

export default component.exports